import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api'; // adjust import path if needed
import {
  Box,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Typography
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // <-- ADDED
import { toast } from 'react-toastify';

function AddAnnouncementPage() {
  const navigate = useNavigate();
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isActive, setIsActive] = useState(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/announcements', {
        title,
        message,
        start_date: startDate,
        end_date: endDate || null,
        is_active: isActive,
      });
      toast.success('Announcement created successfully!');
      navigate('/admin/announcements');
    } catch (error) {
      console.error(error);
      toast.error('Failed to create announcement. Please try again.');
    }
  };

  return (
    <Box sx={{ maxWidth: 600, margin: 'auto', mt: 3 }}>
      {/* Top Bar with Title + Back Button */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 2
        }}
      >
        <Typography variant="h6">Create Announcement</Typography>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </Box>

      <form onSubmit={handleSubmit}>
        <TextField
          label="Title"
          variant="outlined"
          fullWidth
          required
          sx={{ mb: 2 }}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <TextField
          label="Message"
          variant="outlined"
          fullWidth
          multiline
          rows={4}
          required
          sx={{ mb: 2 }}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        <TextField
          label="Start Date"
          type="datetime-local"
          variant="outlined"
          fullWidth
          required
          sx={{ mb: 2 }}
          InputLabelProps={{ shrink: true }}
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />

        <TextField
          label="End Date"
          type="datetime-local"
          variant="outlined"
          fullWidth
          sx={{ mb: 2 }}
          InputLabelProps={{ shrink: true }}
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
              color="primary"
            />
          }
          label="Active"
        />

        <Button
          variant="contained"
          color="primary"
          type="submit"
          sx={{ mt: 2 }}
        >
          Create Announcement
        </Button>
      </form>
    </Box>
  );
}

export default AddAnnouncementPage;
